import React from 'react'
import { useNavigate } from 'react-router-dom';
import LayoutHeader from '../../../layout/LayoutHeader';
import { useSelector } from 'react-redux';

export default function Analytics() {
    const navigate = useNavigate();
    const userArticle = useSelector((state) => state.user.userArticle);

    // Mock data for demonstration - in real app this would come from API
    const metrics = {
        totalViews: '1.2M',
        totalClicks: '89.5K',
        conversionRate: '7.4%',
        activeContent: 156
    };

    const contentTypes = [
        { 
            name: "Video Message", 
            link: "/more/analytics/video-message", 
            views: "342K",
            clicks: "12.3K",
            engagement: "3.6%",
            color: "#FF6B6B"
        },
        { 
            name: "Music", 
            link: "/more/analytics/music", 
            views: "278K",
            clicks: "18.7K",
            engagement: "6.7%",
            color: "#4ECDC4"
        },
        { 
            name: "Video", 
            link: "/more/analytics/video", 
            views: "195K",
            clicks: "8.9K",
            engagement: "4.6%",
            color: "#45B7D1"
        },
        { 
            name: "Event", 
            link: "/more/analytics/event", 
            views: "156K",
            clicks: "15.2K",
            engagement: "9.7%",
            color: "#96CEB4"
        },
        { 
            name: "Product", 
            link: "/more/analytics/product", 
            views: "134K",
            clicks: "11.8K",
            engagement: "8.8%",
            color: "#FECA57"
        },
        { 
            name: "Playlist", 
            link: "/more/analytics/playlist", 
            views: "89K",
            clicks: "6.2K",
            engagement: "7.0%",
            color: "#FF9FF3"
        },
        { 
            name: "Form", 
            link: "/more/analytics/form", 
            views: "67K",
            clicks: "8.9K",
            engagement: "13.3%",
            color: "#54A0FF"
        },
        { 
            name: "Social feed", 
            link: "/more/analytics/socialfeed", 
            views: "45K",
            clicks: "3.1K",
            engagement: "6.9%",
            color: "#5F27CD"
        }
    ];

    const MetricCard = ({ title, value, subtitle, color }) => (
        <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[rgba(255,255,255,0.2)] transition-all">
            <div className="flex items-center gap-2 mb-2">
                <div 
                    className="w-[8px] h-[8px] rounded-full"
                    style={{ backgroundColor: color }}
                />
                <span className="text-[10px] text-[rgba(255,255,255,0.7)] uppercase tracking-wider">
                    {title}
                </span>
            </div>
            <div className="text-white text-[18px] font-bold mb-1">{value}</div>
            {subtitle && (
                <div className="text-[rgba(255,255,255,0.5)] text-[10px]">{subtitle}</div>
            )}
        </div>
    );

    const ContentCard = ({ content }) => (
        <div 
            className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 hover:border-[rgba(255,255,255,0.2)] transition-all cursor-pointer"
            onClick={() => navigate(content.link)}
        >
            <div className="flex items-center gap-x-[15px] mb-3">
                <div 
                    className="w-[24px] h-[24px] rounded-md flex items-center justify-center text-[8px] font-bold text-white"
                    style={{ backgroundColor: content.color }}
                >
                    {content.name.substring(0, 2).toUpperCase()}
                </div>
                <div className="flex items-center gap-x-[10px]">
                    <span className="text-[12px] text-white font-semibold">
                        {content.name}
                    </span>
                    <div 
                        className="w-[8px] h-[8px] rounded-full"
                        style={{ backgroundColor: content.color }}
                    />
                </div>
                <div className="ml-auto">
                    <svg 
                        className="w-4 h-4 text-white opacity-50"
                        fill="none" 
                        stroke="currentColor" 
                        viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                </div>
            </div>
            
            <div className="grid grid-cols-3 gap-2 text-center">
                <div>
                    <div className="text-white text-[12px] font-bold">{content.views}</div>
                    <div className="text-[rgba(255,255,255,0.5)] text-[9px]">Views</div>
                </div>
                <div>
                    <div className="text-white text-[12px] font-bold">{content.clicks}</div>
                    <div className="text-[rgba(255,255,255,0.5)] text-[9px]">Clicks</div>
                </div>
                <div>
                    <div 
                        className="text-[12px] font-bold"
                        style={{ color: content.color }}
                    >
                        {content.engagement}
                    </div>
                    <div className="text-[rgba(255,255,255,0.5)] text-[9px]">Engagement</div>
                </div>
            </div>
        </div>
    );

    return (
        <LayoutHeader>
            <div className="flex justify-center w-full">
                <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
                    {/* Header */}
                    <div className="px-4 my-[50px] flex w-full justify-between">
                        <div className="flex items-center gap-2">
                            <div 
                                className="w-[24px] h-[24px] rounded-md flex items-center justify-center text-[8px] font-bold text-white"
                                style={{ backgroundColor: '#FF3B30' }}
                            >
                                PG
                            </div>
                            <p className="text-white text-[12px]">Pages Analytics</p>
                        </div>
                        <div className="flex items-center gap-4">
                            <p className='text-[red] cursor-pointer text-[12px]'>Export data</p>
                            <div 
                                className="text-white cursor-pointer text-[12px] hover:text-gray-400 transition-colors"
                                onClick={() => navigate('/analytics/hub')}
                            >
                                Back
                            </div>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="w-full px-4 flex-1 overflow-y-auto pb-[100px]">
                        {/* Overall Metrics */}
                        <div className="grid grid-cols-2 gap-3 mb-6">
                            <MetricCard 
                                title="Total Views" 
                                value={metrics.totalViews} 
                                subtitle="All content"
                                color="#FF3B30" 
                            />
                            <MetricCard 
                                title="Total Clicks" 
                                value={metrics.totalClicks} 
                                subtitle="All content"
                                color="#FF3B30" 
                            />
                            <MetricCard 
                                title="Conversion Rate" 
                                value={metrics.conversionRate} 
                                subtitle="Average"
                                color="#FF3B30" 
                            />
                            <MetricCard 
                                title="Active Content" 
                                value={metrics.activeContent} 
                                subtitle="Published"
                                color="#FF3B30" 
                            />
                        </div>

                        {/* Performance Chart Placeholder */}
                        <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 mb-6">
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-[8px] h-[8px] rounded-full bg-[#FF3B30]" />
                                <span className="text-[10px] text-[rgba(255,255,255,0.7)] uppercase tracking-wider">
                                    Performance Overview
                                </span>
                            </div>
                            <div className="h-[120px] bg-[rgba(255,255,255,0.03)] rounded border border-[rgba(255,255,255,0.1)] flex items-center justify-center">
                                <div className="text-center">
                                    <div className="text-[#FF3B30] text-[12px] font-bold mb-2">CHART</div>
                                    <div className="text-[rgba(255,255,255,0.5)] text-[10px]">Performance Chart</div>
                                    <div className="text-[rgba(255,255,255,0.3)] text-[10px]">Interactive chart coming soon</div>
                                </div>
                            </div>
                        </div>

                        {/* Content Types */}
                        <div className="mb-6">
                            <div className="flex items-center gap-2 mb-4">
                                <div className="w-[8px] h-[8px] rounded-full bg-[#FF3B30]" />
                                <span className="text-[10px] text-[rgba(255,255,255,0.7)] uppercase tracking-wider">
                                    Content Analytics
                                </span>
                            </div>
                            <div className="grid gap-4">
                                {contentTypes.map((content, index) => (
                                    <ContentCard key={index} content={content} />
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Help Text with Black Overlay */}
                    <div className="w-full absolute bottom-0 left-0">
                        <div className="bg-black px-4 pt-8 pb-[27px]">
                            <div className="text-[12px] text-[rgba(255,255,255,0.5)] leading-[1.5] max-w-full">
                                <p>Analyze your content performance across all page types.</p>
                                <p>Click on any content type to view detailed analytics.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutHeader>
    );
}
